import { css } from 'react-emotion'

const selectedComment = {
  backgroundColor: '#f6f6f6 !important',
  borderRight: '2px solid #fbbd08 !important'
}

const comment = {
  padding: '0.8em !important',
  boxSizing: 'border-box',
  '&:hover': selectedComment
}

const styles = {
  commentsWrap: css({
    margin: '20px 0',
    height: 'calc(100vh - 150px)',
    overflowY: 'scroll'
  }),
  header: css({
    paddingTop: '18px !important',
    paddingBottom: '2px !important'
  }),
  singleComment: css(comment),
  singleCommentSelected: css({
    ...selectedComment, ...comment
  }),
  replyInputForm: css({
    marginTop: '15px'
  }),
  replyBtnForm: css({
    display: 'none!important'
  }),
  replyRow: css({
    display: 'flex',
    flexDirection: 'row'
  }),
  timeAgo: css({
    color: '#777',
    marginRight: 10
  })
}

export default styles



// WEBPACK FOOTER //
// ./src/Components/Comments/ListStyles.js